import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ExporterGraph } from 'dashboard/models/exporter';
import {
  Graph,
  GraphAttributes,
  GraphExportCluster,
  GraphNodeConfigAttributes,
} from 'dashboard/models/graph';
import { setGraph, setGraphs } from 'dashboard/redux/actions/graph';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function loadGraphsAndGraph(environmentId: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const { data: graphs } = await SessionClientDashboard.listResource<Graph>(ApiEndpoint.Graph);
    dispatch(setGraphs(graphs));

    // Find a graph that matches this environment -- if it exists.
    //
    // If not -- use the first graph
    let relevantGraph = graphs.find((graph) => {
      return graph?.relationships?.environment?.data?.id === environmentId;
    });

    if (relevantGraph == null) {
      relevantGraph = graphs[0];
    }

    dispatch(setGraph(relevantGraph));
  };
}

export function updateGraph(
  graphId: string,
  attributes: GraphAttributes,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const { data: graph } = await SessionClientDashboard.updateResource<Graph>({
      id: graphId,
      type: ApiModel.Graph,
      attributes: attributes,
    });

    dispatch(setGraph(graph));
  };
}

export function updateGraphNodeConfig(
  graphId: string,
  attributes: GraphNodeConfigAttributes,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    // Need to use meta params because 'attributes' expects the entire graph as a type
    const { data: graph } = await SessionClientDashboard.updateResourceAction<Graph>(
      {
        id: graphId,
        type: ApiModel.Graph,
      },
      'update-node-config',
      {
        meta: {
          'datum-type-token': attributes['datum-type-token'],
          'node-render-config': attributes['node-render-config'],
          'node-functions-config': attributes['node-functions-config'],
        },
      },
    );

    dispatch(setGraph(graph));
  };
}

export function loadExporterGraph({
  clusterData,
}: {
  clusterData: GraphExportCluster[];
}): DashboardThunkAction<Promise<void>> {
  return async (_dispatch: Dispatch) => {
    await SessionClientDashboard.postResourceCreate<ExporterGraph>({
      type: ApiModel.ExporterGraph,
      attributes: {
        'export-data': clusterData,
      },
    });
  };
}
